import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import * as Routes from '@/modules/routes';

export type HistoryOutcome = 'accepted' | 'link_only' | 'refused' | 'not_sent' | 'lookup' | 'opened' | 'link_failed';

export interface HistoryEvent {
  id: number;
  at: string;
  outcome: HistoryOutcome;
  method: string | null;
  status: number | null;
  course: string | null;
  /** The LMS course's own title, carried by launches only. */
  course_title?: string | null;
  score_given: number | string | null;
  score_maximum: number | string | null;
  reason: string | null;
  /** The LMS's own message for a refusal. */
  detail: string | null;
}

export interface StudentHistoryPayload {
  student: { id: number; name: string };
  events: HistoryEvent[];
  truncated: boolean;
}

const useStudentHistory = (assignmentId: string, studentId: string) => useQuery({
  enabled: assignmentId !== '' && studentId !== '',
  queryFn: async (): Promise<StudentHistoryPayload> => {
    const { data } = await axios.get(
      Routes.plato_api_sysadmin_grade_sync_student_history_path(assignmentId, studentId),
    );

    return data.data;
  },
  queryKey: ['gradeSyncStudentHistory', assignmentId, studentId],
});

export default useStudentHistory;
